import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import useStripePaiement from "../../hooks/useStripePaiement";

const StripeCheckoutForm = ({setAlert}) => {
  const { createPaiement } = useStripePaiement();
  const stripe = useStripe();
  const elements = useElements();
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

    if (error) {
      console.error(error);
      setAlert({
        message: error.message || "Une erreur s'est produite lors du paiement.",
        type: "danger",
    })
      return;
    }
    createPaiement({
      paymentMethodId: paymentMethod.id,
      amount: 5000, // 50.00 €
      idUser: "693ffa52f09b91d99db085c3", // Remplacez par l'ID réel de l'utilisateur    
      idArticle: "69688918b3f5adb189b33e60", // Remplacez par l'ID réel de l'article
      type: 3, // Remplacez par le type réel de paiement
      devise:"MGA"
    })
      .then((response) => {
        console.log("Paiement réussi :", response);
      })
      .catch((error) => {
        console.error("Erreur de paiement :", error);
        setAlert({
            message: error.message || "Une erreur s'est produite lors du paiement.",
            type: "danger",
        })
      });
  };
  return (
    <form onSubmit={handleSubmit}>
      <CardElement />
      <button>Payer</button>
    </form>
  );
};

export default StripeCheckoutForm;
